import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class CompanySignature extends DomainObject {
  id;
  name;
  signatureData;

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      signatureData: observable
    });

    this.merge(other);
  }
}

export default CompanySignature;
